import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { FooterLabel_EN } from 'src/app/models/labels/footerLabel_EN';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  label: FooterLabel_EN;

  constructor(public dialogRef: MatDialogRef<PrivacyComponent>) { }

  ngOnInit() {
    this.label = new FooterLabel_EN();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
